const SmsCounter = () => {};

// Correct GSM 7-bit characters, including actual \n and \r
SmsCounter.gsm7bitChars =
  '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà';

// Extended characters requiring escape sequences in GSM
SmsCounter.gsm7bitExChar = '^{}\\[~]|€';

// Regular expression for GSM 7-bit characters
SmsCounter.gsm7bitRegExp = new RegExp(
  '^[' +
    SmsCounter.gsm7bitChars.replace(/[\[\]\\^$.*+?()|{}]/g, '\\$&') +
    ']*$',
);

// Regular expression for GSM 7-bit with extended characters
SmsCounter.gsm7bitExRegExp = new RegExp(
  '^[' +
    SmsCounter.gsm7bitChars.replace(/[\[\]\\^$.*+?()|{}]/g, '\\$&') +
    SmsCounter.gsm7bitExChar.replace(/[\[\]\\^$.*+?()|{}]/g, '\\$&') +
    ']*$',
);

// Regular expression for extended characters only
SmsCounter.gsm7bitExOnlyRegExp = new RegExp(
  '[' + SmsCounter.gsm7bitExChar.replace(/[\[\]\\^$.*+?()|{}]/g, '\\$&') + ']',
  'g',
);

SmsCounter.GSM_7BIT = 'GSM_7BIT';
SmsCounter.GSM_7BIT_EX = 'GSM_7BIT_EX';
SmsCounter.UTF16 = 'UTF16';

SmsCounter.messageLength = {
  GSM_7BIT: 160,
  GSM_7BIT_EX: 160,
  UTF16: 70,
};

SmsCounter.multiMessageLength = {
  GSM_7BIT: 153,
  GSM_7BIT_EX: 153,
  UTF16: 67,
};

SmsCounter.count = (text) => {
  let encoding = SmsCounter.detectEncoding(text);
  let length = text.length;

  if (encoding === SmsCounter.GSM_7BIT_EX) {
    // Extended characters count as two
    length += SmsCounter.countGsm7bitEx(text);
  }

  let per_message = SmsCounter.messageLength[encoding];

  // Adjust for multi-part messages
  if (length > per_message) {
    per_message = SmsCounter.multiMessageLength[encoding];
  }

  let messages = Math.ceil(length / per_message);
  let remaining = per_message * messages - length;

  return {
    encoding,
    length,
    per_message,
    remaining,
    messages,
  };
};

SmsCounter.detectEncoding = (text) => {
  if (SmsCounter.gsm7bitRegExp.test(text)) {
    return SmsCounter.GSM_7BIT;
  }
  if (SmsCounter.gsm7bitExRegExp.test(text)) {
    return SmsCounter.GSM_7BIT_EX;
  }
  return SmsCounter.UTF16;
};

SmsCounter.countGsm7bitEx = (text) => {
  // Count occurrences of extended characters
  let matches = text.match(SmsCounter.gsm7bitExOnlyRegExp);
  return matches ? matches.length : 0;
};

export default SmsCounter;
